import React, { useState } from 'react';
import { Typography, TextField, Button, Box, Alert, FormControl, InputLabel, Select, MenuItem, Chip } from '@mui/material';
import { db } from '../utils/firebase';
import { collection, addDoc } from 'firebase/firestore';

const RegistrationRequest = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    modules: [],
    requestDetails: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const availableModules = [
    { id: 'expense-splitter', name: 'Expense Splitter' },
    { id: 'trip-manager', name: 'Trip Manager' },
    { id: 'admin', name: 'Admin Access' }
  ];

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.email.trim() || formData.modules.length === 0) {
      setError('Please fill in all required fields.');
      return;
    }

    try {
      await addDoc(collection(db, 'registration-requests'), {
        name: formData.name.trim(),
        email: formData.email.trim(),
        requestedModules: formData.modules,
        requestDetails: formData.requestDetails.trim(),
        requestedAt: new Date(),
        status: 'pending'
      });
      setSubmitted(true);
      setError('');
    } catch (err) {
      console.error('Error submitting registration request:', err);
      setError('Failed to submit request. Please try again.');
    }
  };

  if (submitted) {
    return (
      <Alert severity="success" sx={{ mt: 2, maxWidth: 500 }}>
        Your registration request has been submitted! An admin will review it soon.
      </Alert>
    );
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, maxWidth: 500, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>Request Access</Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Fill out this form to request access to BonStudio modules.
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <TextField
        label="Full Name"
        value={formData.name}
        onChange={(e) => handleChange('name', e.target.value)}
        fullWidth
        required
        sx={{ mb: 2 }}
      />

      <TextField
        label="Email Address"
        type="email"
        value={formData.email}
        onChange={(e) => handleChange('email', e.target.value)}
        fullWidth
        required
        sx={{ mb: 2 }}
      />

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Modules of Interest</InputLabel>
        <Select
          multiple
          value={formData.modules}
          onChange={(e) => handleChange('modules', e.target.value)}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={availableModules.find(m => m.id === value)?.name} />
              ))}
            </Box>
          )}
        >
          {availableModules.map((module) => (
            <MenuItem key={module.id} value={module.id}>
              {module.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Request Details (Optional)"
        value={formData.requestDetails}
        onChange={(e) => handleChange('requestDetails', e.target.value)}
        fullWidth
        multiline
        rows={3}
        placeholder="Tell us why you need access and how you plan to use BonStudio..."
        sx={{ mb: 2 }}
      />

      <Button type="submit" variant="contained" color="primary" fullWidth>
        Submit Registration Request
      </Button>
    </Box>
  );
};

export default RegistrationRequest;